exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control[data-v-1cd227f0]{margin:0 10px 0 0!important}@media (max-width:768px){.carousel-control[data-v-1cd227f0]{bottom:10px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:18px}}@media (max-width:768px) and (orientation:landscape){.carousel-control[data-v-1cd227f0]{display:none}}.carousel-list[data-v-1cd227f0]{margin-top:-50px;height:370px}@media (max-height:768px){.carousel-list[data-v-1cd227f0]{height:calc(50vh - 30px)!important;padding-bottom:20px}}.carousel-list .q-carousel-inner[data-v-1cd227f0]{height:calc(54vh - 50px)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cd227f0","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/front/Carousel.vue
// module id = guql
// module chunks = 46